import { roles, scopes, PermissionExpression } from 'SRC/hooks/useIdentity';

export const page: PermissionExpression = roles.ADMIN;
export const manageNotifications: PermissionExpression =
  scopes.NOTIFICATIONS_WRITE;
export const manageApiKeys: PermissionExpression = scopes.API_KEYS_WRITE;
